import React, { useState } from "react";

const PaymentMethods = ({ paymentMethods, handlePayment,isCOD }) => {
  const [selected, setSelected] = useState(null);

  const handleSelect = (method) => {
    setSelected(method.PaymentMethodId); // Set selected ID
    handlePayment(method);
  };

  const cashondelivery = {
    PaymentMethodId: 100,
    PaymentMethodAr: "الدفع عند الاستلام",
    PaymentMethodEn: "Cash on Delivery",
    PaymentMethodCode: "COD",
    IsDirectPayment: true,
    ServiceCharge: 0,
    ImageUrl: "https://demo.myfatoorah.com/imgs/payment-methods/kn.png",
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 p-2">
   {isCOD &&  <div
        key={cashondelivery.PaymentMethodId}
        className={`flex flex-col items-center p-2 border rounded-lg shadow-sm hover:shadow-lg transition cursor-pointer ${
          selected === cashondelivery.PaymentMethodId
            ? "border-blue-500 bg-blue-50 shadow-md"
            : "border-gray-300"
        }`}
        onClick={() => handleSelect(cashondelivery)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlSpace="preserve"
          className="w-10 h-10 mb-1 object-contain"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2,
          }}
          viewBox="0 0 32 32"
        >
          <path
            d="M151 165.667c0-.921-.597-1.667-1.333-1.667h-1.334c-.736 0-1.333.746-1.333 1.667v6.666c0 .921.597 1.667 1.333 1.667h1.334c.736 0 1.333-.746 1.333-1.667v-6.666Z"
            style={{
              fill: "#90e0ef",
            }}
            transform="matrix(1.5 0 0 1.2 -217.5 -178.8)"
          />
          <path
            d="M153 165a2 2 0 0 1 2-2h5c.006 0 2 .003 2 2 0 2-2 2-2 2h4.172a2 2 0 0 0 1.414-.586L169 163c2.373-2.373 6.213.272 2.243 4.243l-4.648 5.104a2 2 0 0 1-1.479.653H155a2 2 0 0 1-2-2v-6Z"
            style={{
              fill: "#90e0ef",
            }}
            transform="translate(-144 -144)"
          />
          <path
            d="M29 58.167c0-.84-.274-1.646-.762-2.24C27.751 55.334 27.09 55 26.4 55H5.6c-.69 0-1.351.334-1.838.927-.488.594-.762 1.4-.762 2.24v12.666c0 .84.274 1.646.762 2.24.487.593 1.148.927 1.838.927h20.8c.69 0 1.351-.334 1.838-.927.488-.594.762-1.4.762-2.24V58.167Z"
            style={{
              fill: "#90e0ef",
            }}
            transform="matrix(.76923 0 0 .63158 4.692 -32.737)"
          />
          <path
            d="M105.529 173.615c.445.25.951.385 1.471.385h10.116c.845 0 1.65-.356 2.218-.98l4.633-5.088c1.967-1.976 2.226-3.75 1.831-4.905-.684-1.998-3.46-2.779-5.505-.734l-3.414 3.414a1 1 0 0 1-.707.293h-1.304c.084-.29.132-.621.132-1 0-2.995-2.991-3-2.999-3H107c-.52 0-1.026.135-1.471.385A2.998 2.998 0 0 0 103 161h-2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2a2.998 2.998 0 0 0 2.529-1.385ZM104 164v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm2 1v6a.997.997 0 0 0 1 1h10.116c.282 0 .55-.119.74-.327l4.663-5.121.017-.016c1.196-1.197 1.609-2.163 1.37-2.862-.271-.791-1.389-.776-2.199.033l-3.414 3.414a3 3 0 0 1-2.121.879H109a1 1 0 0 1 0-2h3s1 0 1-1c0-.999-.998-1-1-1h-5a.997.997 0 0 0-1 1Zm18-9v-8c0-.796-.316-1.559-.879-2.121A2.996 2.996 0 0 0 121 145h-16c-.796 0-1.559.316-2.121.879A2.996 2.996 0 0 0 102 148v8c0 .796.316 1.559.879 2.121A2.996 2.996 0 0 0 105 159h16c.796 0 1.559-.316 2.121-.879A2.996 2.996 0 0 0 124 156Zm-2-8v8a.997.997 0 0 1-1 1h-16a.997.997 0 0 1-1-1v-8a.997.997 0 0 1 1-1h16a.997.997 0 0 1 1 1Zm-3 8h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2Zm-6-7a3.001 3.001 0 0 0 0 6 3.001 3.001 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-7-1h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2Z"
            style={{
              fill: "#1990a7",
            }}
            transform="translate(-96 -144)"
          />
        </svg>

        <h3 className="text-sm font-semibold">
          {cashondelivery.PaymentMethodEn}
        </h3>
        <p className="text-xs text-gray-500">
          {cashondelivery.PaymentMethodAr}
        </p>
      </div>
}
      {paymentMethods.map((method) => (
        <div
          key={method.PaymentMethodId}
          className={`flex flex-col items-center p-2 border rounded-lg shadow-sm hover:shadow-lg transition cursor-pointer ${
            selected === method.PaymentMethodId
              ? "border-blue-500 bg-blue-50 shadow-md"
              : "border-gray-300"
          }`}
          onClick={() => handleSelect(method)}
        >
          <img
            src={method.ImageUrl}
            alt={method.PaymentMethodEn}
            className="w-10 h-10 mb-2 object-contain"
          />
          <h3 className="text-sm font-semibold">{method.PaymentMethodEn}</h3>
          <p className="text-xs text-gray-500">{method.PaymentMethodAr}</p>
          <p className="mt-2 text-xs">
            Total:{" "}
            <strong>
              {method.TotalAmount} {method.CurrencyIso}
            </strong>
          </p>

        </div>
      ))}
    </div>
  );
};

export default PaymentMethods;
